module.exports = __webpack_public_path__ + "img/icon_img1.18cc186f.png";